<template>
  <div v-if="active" class="download-modal-overlay" @click.self="fechar">
    <div class="download-modal">
      <div class="download-modal__header">
        <button type="button" class="download-modal__close" @click="fechar" aria-label="Fechar">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="mb-4 p-6 text-white bg-primary rounded">
        <h4 class="text-white mb-2">{{ $t('Warning') }}</h4>
        <div>{{ $t('TxtDownload') }}</div>
        <div>{{ $t('TxtDownloadThree') }}</div>
      </div>

      <div class="mb-3 flex items-center justify-between">
        <small class="text-grey">{{ selected.length }} item(ns) selecionado(s)</small>
        <a href="javascript:;" class="text-primary text-sm" @click="toggleTodos">
          {{ todosSelecionados ? 'Limpar seleção' : 'Selecionar todos' }}
        </a>
      </div>

      <div class="vx-row">
        <div class="vx-col mb-4 w-full lg:w-1/3" v-for="table in tablesMobile" :key="table.id">
          <button
            type="button"
            name="button"
            class="vs-component vs-button vs-button-success vs-button-relief w-full"
            :class="{ 'download-item-selected': isSelected(table.id), 'download-item-unselected': !isSelected(table.id) }"
            @click="toggleItem(table.id)"
            :disabled="processing"
          >
            <span class="vs-button-text vs-button--text">
              <i :class="isSelected(table.id) ? 'fas fa-check' : 'fas fa-download'"></i>
              {{ table.title }}
            </span>
            <span
              class="vs-button-linex"
              style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%);"
            ></span>
          </button>
        </div>
      </div>

      <div class="flex justify-center mt-2" style="gap: 0.75rem;">
        <button
          type="button"
          name="button"
          class="vs-component vs-button vs-button-dark vs-button-relief"
          @click="fechar"
          :disabled="processing"
        >
          <span class="vs-button-text vs-button--text">Cancelar</span>
          <span
            class="vs-button-linex"
            style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%);"
          ></span>
        </button>

        <button
          type="button"
          name="button"
          class="vs-component vs-button vs-button-success vs-button-relief"
          @click="confirmarDownload"
          :disabled="processing || !selected.length"
        >
          <span class="vs-button-text vs-button--text">
            <i class="fas fa-download"></i>
            {{ processing ? 'Baixando...' : 'Confirmar Download' }}
          </span>
          <span
            class="vs-button-linex"
            style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%);"
          ></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DownloadDadosModal',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    device: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      processing: false,
      selected: [],
      tablesMobile: [
        { id: 'whatsapp', title: 'WhatsApp Chat' },
        { id: 'whatsappaudio', title: 'WhatsApp Áudio', available: false },
        { id: 'whatsappcall', title: 'WhatsApp Chamadas' },
        { id: 'instagram', title: 'Instagram' },
        { id: 'telegram', title: 'Telegram' },
        { id: 'tiktok', title: 'Tiktok', available: false },
        { id: 'tinder', title: 'Tinder' },
        { id: 'kwai', title: 'Kwai' },
        { id: 'badoo', title: 'Badoo' },
        { id: 'snapchat', title: 'Snapchat' },
        { id: 'call', title: 'Chamadas' },
        { id: 'keylogger', title: 'Teclas' },
        { id: 'contact', title: 'Contatos' },
        { id: 'webhistory', title: 'Sites' },
        { id: 'websearch', title: 'Pesquisas' },
        { id: 'sms', title: 'SMS' },
        { id: 'location', title: 'Localização' },
        { id: 'remotephoto', title: 'Foto Remota', available: false },
        { id: 'photogallery', title: 'Galeria', available: false },
        { id: 'microphone', title: 'Microfone', available: false },
      ],
    };
  },
  computed: {
    itensDisponiveis() {
      return this.tablesMobile.filter(t => t.available !== false);
    },
    todosSelecionados() {
      return (
        this.itensDisponiveis.length > 0 &&
        this.itensDisponiveis.every(t => this.selected.includes(t.id))
      );
    },
  },
  watch: {
    active(value) {
      if (value) {
        this.selected = [];
        this.processing = false;
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
  },
  beforeDestroy() {
    document.body.style.overflow = '';
  },
  methods: {
    isSelected(id) {
      return this.selected.includes(id);
    },
    toggleItem(id) {
      const table = this.tablesMobile.find(t => t.id === id);
      if (table && table.available === false) {
        this.$vs.notify({
          time: 5000,
          title: 'Aviso',
          text: 'Download ainda não disponível para este tipo de dado.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
        });
        return;
      }

      if (this.isSelected(id)) {
        this.selected = this.selected.filter(item => item !== id);
      } else {
        this.selected.push(id);
      }
    },
    toggleTodos() {
      if (this.todosSelecionados) {
        this.selected = [];
      } else {
        this.selected = this.itensDisponiveis.map(t => t.id);
      }
    },
    fechar() {
      if (this.processing) {
        return;
      }
      this.$emit('close');
    },
    async confirmarDownload() {
      if (!this.device || !this.device.uid) {
        return;
      }

      if (!this.selected.length) {
        this.$vs.notify({
          time: 5000,
          title: 'Aviso',
          text: 'Selecione ao menos um item para baixar.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
        });
        return;
      }

      this.processing = true;
      const version = this.device.panel_version || 1;
      let baixados = 0;
      let falhas = 0;

      for (const id of this.selected) {
        try {
          const response = await this.$api.get(`/api/v${version}/mobile/${id}/${this.device.uid}/download`);

          const url =
            typeof response.data === 'string'
              ? response.data
              : (response.data && response.data.url) || null;

          if (url) {
            window.open(url, '_blank');
            baixados += 1;
          } else {
            falhas += 1;
          }
        } catch (error) {
          falhas += 1;
          const message =
            (error.response && error.response.data && error.response.data.message) || null;
          if (message) {
            this.$vs.notify({
              time: 8000,
              title: 'Falha no download',
              text: message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
            });
          }
        }
      }

      this.processing = false;

      if (baixados > 0) {
        let text = `${baixados} arquivo(s) liberado(s) para download.`;
        if (falhas > 0) {
          text += ` ${falhas} falha(s).`;
        }

        this.$vs.notify({
          time: 10000,
          text,
          iconPack: 'feather',
          icon: 'icon-check',
          color: 'success',
        });
      } else {
        this.$vs.notify({
          time: 6000,
          title: 'Aviso',
          text: 'Não foi possível baixar os itens selecionados.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
        });
      }

      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.download-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 52000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(0, 0, 0, 0.45);
}

.download-modal {
  width: 100%;
  max-width: 900px;
  max-height: 90vh;
  overflow: auto;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
  padding: 1rem 1.5rem 1.5rem;
  position: relative;
}

.download-modal__header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 0.25rem;
}

.download-modal__close {
  border: 0;
  background: transparent;
  color: #626262;
  font-size: 1.1rem;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
}

.download-item-unselected {
  opacity: 0.7;
}

.download-item-selected {
  opacity: 1;
  box-shadow: 0 0 0 2px #fff, 0 0 0 4px #28c76f;
}
</style>
